import { ReactElement } from 'react';
import cc from 'classcat';
import { isRtl } from 'utils/constants/app/rtl';
import { EIconSize } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { ESportsbookLayoutTypes } from 'interfaces/sportsbook-configs';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import './index.less';

type TGameHeaderSkeletonProps = {
  customArrow?: boolean;
  esport?: boolean;
};

export const GameHeaderSkeleton = ({
  esport
}: TGameHeaderSkeletonProps): ReactElement => {
  const configs = useSportsbookConfigs();
  const isEuropeanLayout =
    configs.spbLayoutType === ESportsbookLayoutTypes.EUROPEAN;

  return (
    <div
      className={cc([
        'gameHeader__Container',
        { 'gameHeader__Container--mobile': isMobile() }
      ])}
    >
      <div className="flexWrapper">
        <Skeleton.Avatar
          style={{
            width: EIconSize._12,
            maxWidth: EIconSize._12,
            height: EIconSize._12,
            ...(isRtl ? { marginLeft: 4 } : { marginRight: 4 })
          }}
        />
        <Skeleton.Avatar
          style={{
            width: EIconSize._24,
            maxWidth: EIconSize._24,
            height: EIconSize._24,
            ...(isRtl ? { marginRight: 4 } : { marginLeft: 4 })
          }}
        />
        <div
          className={cc([
            'gameHeader__title',
            {
              'gameHeader__title--mobile': isMobile(),
              'gameHeader__title--european': isEuropeanLayout && !isMobile()
            }
          ])}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Skeleton
            active
            round
            title={{
              width: isMobile() ? '40%' : '25%',
              style: { height: 15, margin: 0 }
            }}
            paragraph={false}
          />
          {!isMobile() && esport && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Skeleton
                active
                round
                style={{
                  flex: 1
                }}
                title={{
                  style: {
                    borderRadius: 4,
                    width: 64,
                    height: 32,
                    margin: 0,
                    justifyContent: 'center'
                  }
                }}
                paragraph={false}
              />
              <Skeleton.Button
                className="eSportGameSingleViewSkeletonDesktopLive__gameDetailsSkeleton__end"
                active
                style={{
                  borderRadius: 4,
                  margin: 0,
                  justifyContent: 'center',
                  width: 32,
                  height: 32,
                  minWidth: 'unset'
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
